<template>
  <div class="knowledge-exam-clazz-detail-page">
    <title-bar title="答题表现" back>
      <el-button type="primary" @click="notifyStudent">通知学生</el-button>
    </title-bar>

    <div class="main">
      <training-overview-info v-if="exam" :training="exam" :format="formatExamTime"></training-overview-info>
      <training-clazz-static-info :clazz-summary-items="clazzSummaryInfo"></training-clazz-static-info>
      <list-page class="list-page" :data="items" :limit="query.limit">
        <el-table-column label="班级">
          <template v-slot="{ row }">
            {{ row.class_vo.note_name || row.class_vo.name }}
          </template>
        </el-table-column>

        <el-table-column label="人数">
          <template v-slot="{ row }">
            {{ row.students_count }}
          </template>
        </el-table-column>

        <el-table-column v-if="isEnd" label="完成人数">
          <template v-slot="{ row }">
            {{ row.completion_count }}
          </template>
        </el-table-column>
        <el-table-column v-if="isEnd" label="平均分">
          <template v-slot="{ row }">
            <div class="avg-score" :class="[calcScoreStatus(row.avg_score)]" v-if="isEnd">
              {{ formatAvgScore(row.avg_score) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column v-if="!isEnd" label="进行中">
          <template v-slot="{ row }">
            {{ row.attending_count }}
          </template>
        </el-table-column>
        <el-table-column v-if="!isEnd" label="未开始">
          <template v-slot="{ row }">
            {{ row.un_start_count }}
          </template>
        </el-table-column>

        <el-table-column prop="action" label="更多操作" align="center">
          <template v-slot="{ row }">
            <el-button type="text" @click="navToStudentStatic(row)">详情</el-button>
          </template>
        </el-table-column>
      </list-page>

      <el-dialog
        width="400px"
        v-if="examStatisticInfo && invitePosterDialogVisible"
        :visible.sync="invitePosterDialogVisible"
      >
        <exam-poster-base-comp :exam-statistic-info="examStatisticInfo" />

        <a v-if="base64" class="download" :href="base64" download="优秀名单.png">保存图片</a>

        <html-poster v-if="posterKey" :key="posterKey" @generate="setImg">
          <exam-poster-base-comp :exam-statistic-info="examStatisticInfo" />
        </html-poster>
      </el-dialog>
    </div>
  </div>
</template>
<script lang="ts">
import { BasePage, Component, Prop } from 'kuaidong-component'
import TitleBar from '@/components/TitleBar.vue'
import TrainingOverviewInfo from '@/views/special-skill/components/TrainingOverviewInfo.vue'
import TrainingClazzStaticInfo from '@/views/special-skill/components/TrainingClazzStaticInfo.vue'
import ListPage from '@/components/ListPage.vue'
import {
  HomeworkClazzStat,
  IClazzStaticSummary,
  IPaperExamStaticInfo,
  IPaperExamStaticInfoSummary,
} from 'kuaidong-model'
import { Emit } from 'vue-property-decorator'
import { AWinter2023 } from 'kuaidong-api'
import { DateWrapper, UnitUtil } from 'kuaidong-lib'
import { NewCourseLiveService } from 'kuaidong-service'
import { HtmlPoster } from 'kuaidong-component'

import ExamPosterBaseComp from '@/views/pe-knowledge/components/ExamPosterBase.vue'
@Component({
  components: {
    TitleBar,
    TrainingOverviewInfo,
    TrainingClazzStaticInfo,
    ListPage,
    HtmlPoster,
    ExamPosterBaseComp,
  },
})
export default class KnowledgeExamClazzDetailPage extends BasePage {
  @Prop({
    type: String,
    required: true,
  })
  id!: string

  invitePosterDialogVisible = false
  query = {
    limit: 20,
  }
  summaryItems: IClazzStaticSummary[] = []

  examStatisticInfo: IPaperExamStaticInfo | null = null
  actions = [
    {
      label: '查看题目',
      action: 'examDetail',
    },
  ]
  base64 = ''
  shareLoading = false
  posterKey = 0

  setImg(b64: string) {
    this.base64 = b64
  }
  share() {
    this.posterKey += 1
    this.shareLoading = true
  }

  mounted() {
    this.share()
  }

  get service() {
    return NewCourseLiveService
  }

  get exam() {
    if (this.examStatisticInfo) {
      return {
        name: this.examStatisticInfo.exam.title,
        ...this.examStatisticInfo.exam,
      }
    } else {
      return null
    }
  }

  get summaryInfo() {
    if (this.examStatisticInfo) {
      return this.examStatisticInfo.class_total_summary
    } else {
      return null
    }
  }

  get clazzSummaryInfo() {
    if (!this.isEnd) {
      return [
        {
          value: this.summaryInfo?.students_count,
          title: '学生人数',
        },
        {
          value: this.summaryInfo?.attending_count,
          title: '进行中',
        },
        {
          value: this.summaryInfo?.un_start_count,
          title: '未开始',
        },
        {
          value: this.summaryInfo ? this.formatAvgScore(this.summaryInfo.avg_score) : undefined,
          title: '平均分',
        },
      ]
    } else {
      return [
        {
          value: this.summaryInfo?.students_count,
          title: '学生人数',
        },
        {
          value: this.summaryInfo?.completion_count,
          title: '已完成',
        },
        {
          value: this.summaryInfo?.un_start_count,
          title: '未开始',
        },
        {
          value: this.summaryInfo ? this.formatAvgScore(this.summaryInfo.avg_score) : undefined,
          title: '平均分',
        },
      ]
    }
  }

  get items() {
    if (this.examStatisticInfo) {
      return this.examStatisticInfo.class_summary_list
    } else {
      return []
    }
  }

  get isEnd() {
    return this.exam && this.exam.status === 'END'
  }

  get clazzOptions() {
    if (this.examStatisticInfo && this.examStatisticInfo.class_summary_list) {
      return this.examStatisticInfo.class_summary_list.map((item) => {
        return {
          label: item.class_vo.note_name || item.class_vo.name,
          value: item.class_vo.id,
        }
      })
    } else {
      return []
    }
  }

  calcScoreStatus(score: number) {
    if (score <= 20) {
      return 'failed'
    } else if (score <= 50) {
      return 'not-good'
    } else {
      return 'pass'
    }
  }

  @Emit('navToDetail')
  handleClick(item: HomeworkClazzStat) {
    return item
  }

  formatAvgScore(avg: number) {
    return UnitUtil.toFixed(+avg, 2)
  }

  formatRate(rate: number) {
    return UnitUtil.percent(rate)
  }

  formatExamTime(dt: string) {
    return new DateWrapper(dt).showStrFullDate
  }

  handleAction(action: string) {
    if (action === 'examDetail') {
      this.navToExamDetail()
    }
  }

  notifyStudent() {
    this.invitePosterDialogVisible = true
  }

  navToExamDetail() {
    this.$router.push({
      name: 'winter_2023_exam_detail',
      query: {
        id: this.exam?.paper_id,
      },
    })
  }

  navToStudentStatic(item: IPaperExamStaticInfoSummary) {
    this.$router.push({
      name: 'pe_knowledge_exam_student_detail',
      query: {
        examId: this.exam?.online_exam_id,
        classId: `${item.class_vo.id}`,
        clazzOption: JSON.stringify(this.clazzOptions),
      },
    })
  }

  async created() {
    this.fetchExamStatisticClazzSummary()
  }

  async fetchExamStatisticClazzSummary() {
    this.examStatisticInfo = await AWinter2023.examStatisticClazzSummary(this.id)
  }

  formatDate(dt: string) {
    return `${new DateWrapper(dt).showDateStrShort3}  ${new DateWrapper(dt).showTimeStr}`
  }
}
</script>
<style lang="less">
.knowledge-exam-clazz-detail-page {
  > .main {
    padding: 22px 24px;
    background: #fff;

    > .list-page {
      margin-top: 24px;
      padding: 0;

      > .el-table {
        > .el-table__body-wrapper {
          > .el-table__body {
            > tbody {
              > .el-table__row {
                > td {
                  > .cell {
                    > .avg-score {
                      &.failed {
                        color: #f24b53;
                      }
                      &.not-good {
                        color: #fe9647;
                      }
                      &.pass {
                        color: #3bb528;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    > .el-dialog__wrapper {
      > .el-dialog {
        > .el-dialog__body {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          > .download {
            background: var(--shs-theme-primary);
            border-radius: 8px;
            font-weight: 500;
            font-size: 16px;
            line-height: 16px;
            text-align: center;
            letter-spacing: 1px;

            padding: 14px 116px;
            color: #ffffff;
            box-sizing: border-box;
          }
          > .html-poster {
            width: 375px;
          }
        }
      }
    }
  }
}
</style>
